import React, { createContext, useContext } from "react"

const DEFAULT_BASE = "/weekly-trainings"

export const WeeklyTrainingRoutesContext = createContext<{ basePath: string }>({
  basePath: DEFAULT_BASE,
})

export const WeeklyTrainingRouteProvider: React.FC<{
  basePath: string
  children: React.ReactNode
}> = ({ basePath, children }) => (
  <WeeklyTrainingRoutesContext.Provider value={{ basePath }}>
    {children}
  </WeeklyTrainingRoutesContext.Provider>
)

export function useWeeklyTrainingBasePath() {
  return useContext(WeeklyTrainingRoutesContext).basePath
}
